import React from 'react'
import { Combobox } from '@node-space/ui-components'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'

type BankCountrySelectProps = {
  register: UseFormRegister<ContactFiatInstrumentFormData>
  errors: FieldErrors<ContactFiatInstrumentFormData>
  countriesLoading: boolean
  internationalCountryList: Array<{ leftText: string; value: string }>
  bankCountryCode?: string
  onInternationalCountrySelection: (countryCode: string) => void
}

export const BankCountrySelect = ({
  register,
  errors,
  countriesLoading,
  internationalCountryList,
  bankCountryCode,
  onInternationalCountrySelection,
}: BankCountrySelectProps) => {
  const { t } = useTranslation()

  return (
    <Combobox
      {...register('bankCountryCode')}
      key={bankCountryCode}
      label={t('country')}
      id={t('bankCountryCode')}
      selectPlaceholder={t('searchOrSelectACountry')}
      items={internationalCountryList}
      onChange={onInternationalCountrySelection}
      loading={countriesLoading}
      defaultValue={bankCountryCode}
      errorText={errors?.bankCountryCode?.message}
    />
  )
}

